import React from 'react';
import './dialog.scss'
export const Dialog = ({ open, onOpenChange, children }) => {
    if (!open) return null;

    return (
        <div className="dialog-backdrop" onClick={() => onOpenChange(false)}>
            <div className="dialog-container" onClick={(e) => e.stopPropagation()}>
                {children}
            </div>
        </div>
    );
};

export const DialogHeader = ({ children }) => (
    <div className="dialog-header">
        {children}
    </div>
);

export const DialogContent = ({ children }) => (
    <div className="dialog-content">
        {children}
    </div>
);

export const DialogTitle = ({ children }) => (
    <h2>{children}</h2>
);
